import axios from '@/plugins/axios'
import { getAccountId } from '@/helper/auth-helper'

const getLogin = formData => axios.post('auth/login', formData)
const checkUserAccess = () => axios.post('auth/check')
const getLogout = () => axios.post('auth/logout')
const getLogoutAll = () => axios.post('auth/logout-all')
const updatePassword = formData => axios.patch('auth/password', formData)

const sendEmailForResetPassword = params => axios.get('auth/reset-password', { params })
const checkResetToken = token => axios.get(`auth/reset-password/${token}`)
const sendNewPassword = ({ token, formData }) => axios.post(`auth/reset-password/${token}`, formData)

export { getLogin, checkUserAccess, getLogout, getLogoutAll, updatePassword, sendEmailForResetPassword, checkResetToken, sendNewPassword }
